export const CONFIGURATION = 'Configuration';
export const TABS = [
  { name: 'App Configuration', key: 'APP' },
  { name: 'Style Configuration', key: 'STYLE' },
];
export const APP = 'APP';
export const STYLE = 'STYLE';

export const TITLE = {
  APP: 'App Configuration',
  STYLE: 'Style Configuration',
};
